<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp; Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="quickSearch" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="0">
              <a-collapse-panel key="0">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="filter.searchDate"
                    format="DD-MM-YYYY"
                    allowClear
                  />
                </div>
                
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataListSlot
        title="Account Receivable Employee List"
        createLink="pembayaranpiutang-create-hrd"
        manifestLink="pembayaranpiutang-manifest-hrd"
        editLink="pembayaranpiutang-edit-hrd"
        :disabledCreateEditLink="!allowCreate"
        :fileStatus="true"
        :dataList="datasource"
        :loading="loading"
      >
        <!-- <div slot="status" slot-scope="data">
          <status :status="data.item.closeStatus" />
        </div> -->
        <div
          
          class="m-display-flex flex-row space-between"
          slot="status_file"
          slot-scope="data"
        >
          <span class="margin-remove">BKM</span>
          <a-tag
            :color="data.item.bkm=='File Have Been Upload' ? 'green' : ''"
            class="margin-remove"
          >
            {{ data.item.bkm ? data.item.bkm : "No File Upload"  }}
           
          </a-tag>
        </div>

        <a-button-group slot="actions" slot-scope="item">
          <a-button
            v-if="
              item.source.status_besar == 'Revised'
            "
            icon="edit"
            @click="handleRevise(item.source)"
            >Revise</a-button
          >
        </a-button-group>
      </DataListSlot>
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "pembayaranPiutang",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: false,
      rawData: [],
      filter: {
        searchDate: null,
        type: undefined,
      },
      quickSearch: "",
      allowCreate: this.$route.meta.ishrd,
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",  
      "getListPembayaranPiutang",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getStatus",
    ]),
    datasource() {
      let outputData = this.rawData;

      if (this.quickSearch) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.keyword &&
            obj.keyword.indexOf(this.quickSearch.toLowerCase()) >=
              0
        );
      }

      if (this.filter.searchDate) {
        let filter = moment(this.filter.searchDate).format(
          this.getStandartFormatDate
        );
        outputData = _.filter(outputData, (obj) => 
          moment(obj.create_dt).format(this.getStandartFormatDate) == filter);
      }

      

      return outputData;
    },
    isHRD(){
      let res = false
      this.getAuth.divisi.forEach(element => {
        if(element.toLowerCase()=='hrd'){
          res = true
        }
      });
      return res
    },
  },
  mounted() {
    if(!this.isHRD){
      this.allowCreate = false;
    }

    this.fetch();
  },
  methods: {
    moment,
    fetch() {
      this.loading = true;
      this.$store
        .dispatch("getListPembayaranPiutang", { auth: this.getAuth })
        .then((res) => {
          res.data.forEach((data) => {
            this.rawData.push({
              id: data.piutang_karyawan_byr_id,
              title: data.no_trans,
              create_dt: data.create_dt,
              bkm: data.bkm,
              keyword:
                data.no_trans.toLowerCase() +" "+
                data.tlc_create.toLowerCase() +" "+
                moment(data.create_dt).format('DD-MM-YYYY') +" "+
                this.formatCurrency("IDR", data.nominal).toLowerCase(),
                
              subdesc: [
                data.tlc_create + " | " + moment(data.create_dt).format('DD-MM-YYYY'),
                data.description,
                [
                   
                  {
                    label: "Value",
                    value: this.formatCurrency("IDR", data.total_value),
                  },
                  {
                    label: "Note",
                    value: data.catatan,
                  },
                  
                ],
              ],
              timeline: data.status_app ? JSON.parse(data.status_app) : [],
              status_besar: data.status_besar
            });
          });
          this.loading = false;
        });
    },
    handleRevise(item) {
      this.$router.push({
        name: "pembayaranpiutang-edit-hrd",
        params: { id: item.id, type: "revisi" },
      });
    },
    handleAmandemen(item) {
      this.$router.push({
        name: "financing-edit",
        params: { id: item.id, type: "amandemen" },
      });
    },
  },
};
</script>

<style></style>
